import { useQuery } from "@tanstack/react-query";
import { fetchTestimonial, getForm } from "./endpoints";
import { TestimonialQuery } from "./types";
import { CollectionForm } from "@/api/types";

export const useFetchTestimonials = (filters: TestimonialQuery) => {
  return useQuery({
    queryFn: () => fetchTestimonial(filters),
    queryKey: ["testimonials", filters],
  });
};

export const useFetchForm = (id: string) => {
  return useQuery<CollectionForm>({
    queryFn: () => getForm(id),
    queryKey: ["forms", id],
  });
};
